import { useQuery } from '@tanstack/react-query';
import { getPortLoadings } from '../services/portLoadingService';
import { queryKeys } from '../constants/queryKeys';

/**
 * usePortLoadings — Fetch all port-loading origins
 * Returns array of { country, countryCode, ... } objects
 */
export const usePortLoadings = () => {
  return useQuery({
    queryKey: queryKeys.portLoading.all,
    queryFn: () => getPortLoadings(),
    staleTime: 5 * 60 * 1000, // cache for 5 minutes
  });
};
